import type { MessageThreadUrlCode } from '../../../../common/api/graphql/getMessageThread';
import { messageThreadPostedMessageObserver } from '../../../../common/api/graphql/messageThreadPostedMessageObserverGql';
import type { MessageThreadPostedMessageSubscriptionResponse } from '../../../../common/api/graphql/messageThreadPostedMessageObserverGql';
import {
  receiveMessageThreadPostedMessageFailure,
  receiveMessageThreadPostedMessageSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';

const messageThreadPostedMessageObserverNextThunk =
  (
    response: MessageThreadPostedMessageSubscriptionResponse
  ): AppThunkAction<void> =>
  dispatch => {
    dispatch(
      receiveMessageThreadPostedMessageSuccess(
        response.data!.messageThreadMessageWasPosted.message
      )
    );
  };

const messageThreadPostedMessageObserverErrorThunk =
  (): AppThunkAction<void> => dispatch => {
    dispatch(receiveMessageThreadPostedMessageFailure());
    // cf.https://github.com/giftee/ikedayama/issues/4780
    // return dispatch(handleApiErrorIfNeeded(error));
  };

export const subscribeMessageThreadPostedMessageThunk =
  (messageThreadUrlCode: MessageThreadUrlCode): AppThunkAction<void> =>
  dispatch => {
    messageThreadPostedMessageObserver(messageThreadUrlCode).subscribe({
      next(data) {
        dispatch(messageThreadPostedMessageObserverNextThunk(data));
      },
      error() {
        dispatch(messageThreadPostedMessageObserverErrorThunk());
      }
    });
  };
